import { JsonObject, JsonProperty } from 'json2typescript';
import Resource from '@/models/exam/Resource';
import BenefitsResource from '@/models/exam/BenefitsResource';
import News from '@/models/exam/News';

@JsonObject('ExamInfo')
export default class ExamInfo {
  constructor() {
    this.examTitle = undefined;
    this.periodStart = undefined;
    this.periodEnd = undefined;
    this.overview = undefined;
    this.about = undefined;
    this.fee = undefined;
    this.useNameFlg = false;
    this.useNameKanaFlg = false;
    this.useGenderFlg = false;
    this.useAddressFlg = false;
    this.useMailAnnounceFlg = false;
    this.usePaymentsKonbiniFlg = undefined;
    this.usePaymentsSerialFlg = false;
    this.konbiniExpireDays = undefined;
    this.rankTitle = undefined;
    this.paymentType = undefined;
    this.inPeriod = false;
  }

  @JsonProperty('exam_title')
  public examTitle?: string;

  @JsonProperty('period_start')
  public periodStart?: string;

  @JsonProperty('period_end')
  public periodEnd?: string;

  @JsonProperty('overview')
  public overview?: string;

  @JsonProperty('about')
  public about?: string;

  @JsonProperty('fee')
  public fee?: string;

  @JsonProperty('use_name_flg')
  public useNameFlg: boolean;

  @JsonProperty('use_name_kana_flg')
  public useNameKanaFlg: boolean;

  @JsonProperty('use_gender_flg')
  public useGenderFlg: boolean;

  @JsonProperty('use_address_flg')
  public useAddressFlg: boolean;

  @JsonProperty('use_mail_announce_flg')
  public useMailAnnounceFlg: boolean;

  @JsonProperty('use_payments_konbini_flg', null, true)
  public usePaymentsKonbiniFlg?: number;

  @JsonProperty('use_payments_serial_flg')
  public usePaymentsSerialFlg: boolean;

  @JsonProperty('konbini_expire_days', null, true)
  public konbiniExpireDays?: number;

  @JsonProperty('resources')
  public resources: Array<Resource> = [];

  @JsonProperty('benefits_resources')
  public benefitsResources: Array<BenefitsResource> = [];

  @JsonProperty('news')
  public news: Array<News> = [];

  // 内部パラメータ
  public rankTitle?: string;

  public paymentType?: string;

  public inPeriod: boolean;
}
